import type { InsightsOverviewResponse } from "@nlc/shared-types";

import { formatMetric } from "../formatMetric";
import { POST_FORMAT_LABELS } from "../postFormatLabels";
import { Card } from "./Card";

export function FormatBreakdown({
  className,
  formats,
}: {
  className?: string;
  formats: InsightsOverviewResponse["formats"];
}) {
  const rows = formats.map((entry) => ({
    ...entry,
    averageViews: Math.round(entry.views / entry.posts),
  }));
  const maxAverage = Math.max(...rows.map((row) => row.averageViews), 1);

  return (
    <Card className={className} title="Post type">
      <p className="-mt-md text-sm text-text-tertiary">
        Average views per post for each type.
      </p>
      <ul className="flex flex-col gap-lg">
        {rows.map((row) => (
          <li className="flex flex-col gap-sm" key={row.format}>
            <div className="flex items-baseline justify-between gap-md text-sm">
              <span className="font-medium text-text-secondary">
                {POST_FORMAT_LABELS[row.format]}
                <span className="ml-xs font-normal text-text-tertiary">
                  ({row.posts} {row.posts === 1 ? "post" : "posts"})
                </span>
              </span>
              <span className="font-semibold text-text-primary">
                {formatMetric(row.averageViews)} views
              </span>
            </div>
            <div className="h-2 overflow-hidden rounded-full bg-bg-tertiary">
              <div
                className="h-full rounded-full bg-fg-brand-primary"
                style={{ width: `${(row.averageViews / maxAverage) * 100}%` }}
              />
            </div>
          </li>
        ))}
      </ul>
    </Card>
  );
}
